import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const GetCategoryTypeList = () =>
  GET_ENC(API_ENDPOINTS.CATEGORY.GET_LIST_FOR_CATEGORY_TYPE, null);

export const GetCategoryDetail = (params: any) =>
  GET_ENC(API_ENDPOINTS.CATEGORY.GET_DETAIL + params, null);

export const GetCategoryList = (params: any) =>
  GET_ENC(API_ENDPOINTS.CATEGORY.GET_LIST + params, null);

export const CreateCategory = (data: any) =>
  POST_ENC(API_ENDPOINTS.CATEGORY.CREATE, data);

export const UpdateCategory = (data: any) =>
  POST_ENC(API_ENDPOINTS.CATEGORY.UPDATE, data);

export const DeleteCategory = (data: any) =>
  POST_ENC(API_ENDPOINTS.CATEGORY.DELETE, data);


